module.exports = __webpack_public_path__ + "static/img/royal.864a960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patrocinio/royal.jpg
// module id = P9SO
// module chunks = 1